/* Automatic generated by './build/bin/build-entry.js' */

import Overview from './packages/overview/overview'
import Sidemenu from './packages/sidemenu/sidemenu'
import Usermenu from './packages/usermenu/usermenu'
import Settingspanel from './packages/settingspanel/settingspanel'
import Inventorypanel from './packages/inventorypanel/inventorypanel'
import Om61inventorypanel from './packages/om61inventorypanel/om61inventorypanel'
import Tariffspanel from './packages/tariffspanel/tariffspanel'
import AcceptablesPanel from './packages/acceptablespanel/acceptablespanel'
import MinimumOrderCoinRollsPanel from './packages/minimumordercoinrollspanel/minimumordercoinrollspanel'
import CoinDistributionPanel from './packages/coindistributionpanel/coindistributionpanel'

const components = [
  Overview,
  Sidemenu,
  Usermenu,
  Settingspanel,
  Inventorypanel,
  Om61inventorypanel,
  Tariffspanel,
  AcceptablesPanel,
  MinimumOrderCoinRollsPanel,
  CoinDistributionPanel
]

const install = function (Vue, opts = {}) {
  if (install.installed) return

  components.map(component => {
    Vue.component(component.name, component)
  })

 // Vue.use(Loading.directive)
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

module.exports = {
  Overview,
  install,
  version: '1.0.0'
}



// WEBPACK FOOTER //
// ./src/dq-ui/index.js